// rv-product-tabs: loaded only where the section is used (sections/rv-product-tabs.liquid)

class RvProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab.dataset.blockId));
      tab.addEventListener('keydown', this.onTabKeydown);
    });

    this.querySelectorAll('.rv-carousel').forEach((carousel) => {
      const track = carousel.querySelector('.rv-carousel__track');
      const update = () => this.updateArrows(carousel);
      track.addEventListener('scroll', update, { passive: true });
      carousel.querySelectorAll('.rv-carousel__arrow').forEach((arrow) => {
        arrow.addEventListener('click', () => {
          track.scrollBy({ left: track.clientWidth * Number(arrow.dataset.direction), behavior: 'smooth' });
        });
      });
      update();
    });

    this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.rv-carousel').forEach((c) => this.updateArrows(c)));
    this.resizeObserver.observe(this);

    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  select(blockId, focus = false) {
    this.tabs.forEach((tab) => {
      const selected = tab.dataset.blockId === blockId;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      if (selected && focus) tab.focus();
    });
    this.querySelectorAll('.rv-tabs__panel').forEach((panel) => {
      panel.hidden = panel.dataset.blockId !== blockId;
      if (!panel.hidden) this.updateArrows(panel.querySelector('.rv-carousel'));
    });
  }

  updateArrows(carousel) {
    if (!carousel) return;
    const track = carousel.querySelector('.rv-carousel__track');
    const [prev, next] = carousel.querySelectorAll('.rv-carousel__arrow');
    const maxScroll = track.scrollWidth - track.clientWidth;
    carousel.querySelector('.rv-carousel__controls').toggleAttribute('data-hidden', maxScroll <= 1);
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= maxScroll - 1;
  }

  onTabKeydown = (event) => {
    const index = this.tabs.indexOf(event.currentTarget);
    let target;
    if (event.key === 'ArrowRight') target = this.tabs[(index + 1) % this.tabs.length];
    if (event.key === 'ArrowLeft') target = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
    if (event.key === 'Home') target = this.tabs[0];
    if (event.key === 'End') target = this.tabs[this.tabs.length - 1];
    if (!target) return;
    event.preventDefault();
    this.select(target.dataset.blockId, true);
  };

  onBlockSelect = (event) => {
    if (this.querySelector(`[role="tab"][data-block-id="${event.detail.blockId}"]`)) {
      this.select(event.detail.blockId);
    }
  };
}

if (!customElements.get('rv-product-tabs')) customElements.define('rv-product-tabs', RvProductTabs);
